import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { orderTranslationChunksConfig, orderTranslationsEn } from '@spartacus/order/assets';
import { OrderRootModule, ORDER_FEATURE } from '@spartacus/order/root';
import { CustomOrderHistoryModule } from './components/order-history/custom-order-history.module';
import { customOrdersOccConfig } from './core/order.occ';

@NgModule({
  declarations: [],
  imports: [OrderRootModule, CustomOrderHistoryModule],
  providers: [
    provideConfig(customOrdersOccConfig),
    provideConfig(<CmsConfig>{
      featureModules: {
        [ORDER_FEATURE]: {
          module: () => import('./order.module').then(m => m.CustomOrderModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: orderTranslationsEn },
        chunks: orderTranslationChunksConfig,
      },
    }),
  ],
})
export class OrderFeatureModule {}
